import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import ButtonGroup from "../../components/ButtonGroup";
import CustomTableSimple from "../../components/CustomTableSimple";
import ErrorMessage from "../../components/ErrorMessage";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Main from "../../components/Main";
import SideMenu from "../../components/SideMenu";
import SimpleButton from "../../components/SimpleButton";
import Spacer from "../../components/Spacer";
import SubPage from "../../components/SubPage";
import SubPagesContainer from "../../components/SubPagesContainer";
import history from "../../providers/history";
import { IApplicationState } from "../../store";
import { systemAddDialog } from "../../store/system/slice";
import { itemsNamesListRequest, startEditingItemName, itemNameRemoveRequest } from "../../store/itemsNames/slice";
import ItemNameForm from "../ItemNameForm";
import { Container, Content } from "./styles";
import { profileUserRequest } from "../../store/authentication/slice";

const ItemName: React.FC = () => {
    const itemsNames = useSelector((state: IApplicationState) => state.itemsNames)

    const { t } = useTranslation();

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(itemsNamesListRequest())
        dispatch(profileUserRequest())
    }, [dispatch]);

    return <Container id="container">
        <Header />

        <Content>
            <SideMenu />
            <Main>
                <h1>{t("pages.items_names.title")}</h1>

                <Spacer size={20} />
                {itemsNames.isLoading && <>
                    <p>{t("pages.items_names.loading")}</p>
                </>}



                <ButtonGroup>
                    <SimpleButton color="primary" prependIcon="plus" onClick={() => {
                        dispatch(startEditingItemName({
                            name: "",
                        }))
                        history.push("item-name/form")
                    }}>{t("pages.items_names.buttons.add_name")}</SimpleButton>
                </ButtonGroup>

                <Spacer size={20} />

                {!itemsNames.isLoading && !itemsNames.error && itemsNames.data.length === 0 && (
                    <>
                        <ErrorMessage>
                            {t("pages.items_names.not_found")}
                        </ErrorMessage>
                    </>
                )}

                <Spacer size={20} />

                {!itemsNames.isLoading && !itemsNames.error && itemsNames.data.length > 0 && <>
                    <CustomTableSimple>
                        <thead>
                            <tr>
                                <th style={{ minWidth: 250 }}>{t("pages.items_names.name")}</th>
                                <th style={{ minWidth: 150, width: 150 }}>{t("pages.items_names.actions")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {itemsNames.data.map(itemName => <tr key={`name-id-${itemName.id}`}>
                                {itemName.isDeleting && <>
                                    <td colSpan={3}>{t("pages.items_names.deleting")}</td>
                                </>}

                                {!itemName.isDeleting && <>
                                    <td>
                                        {itemName.name}
                                        {itemName.error && <p>{itemName.error.message}</p>}
                                    </td>
                                    <td>
                                        <ButtonGroup>
                                            <SimpleButton size={'small'} prependIcon='pencil' color='primary' onClick={() => {
                                                dispatch(startEditingItemName(itemName));
                                                history.push(`/settings/item-name/${itemName.id}/form`)
                                            }}>{t("common.buttons.edit")}</SimpleButton>
                                            <SimpleButton size={'small'} prependIcon='trash' color='danger' onClick={() => {
                                                return dispatch(systemAddDialog({
                                                    title: t("pages.items_names.dialogs.remove_name"),
                                                    message: t("pages.items_names.dialogs.remove_name_message"),
                                                    actions: [{
                                                        text: t("pages.items_names.buttons.remove_name_confirm"),
                                                        action: () => {
                                                            dispatch(itemNameRemoveRequest(itemName.id || ''));

                                                            history.push(`/settings/item-name`)
                                                        },
                                                        color: 'danger',
                                                        prependIcon: 'trash'
                                                    },
                                                    {
                                                        text: t("pages.items_names.buttons.remove_name_cancel"),
                                                        action: () => { },
                                                        color: 'none'
                                                    }]
                                                }));
                                            }}>{t("common.buttons.delete")}</SimpleButton>
                                        </ButtonGroup>
                                    </td>
                                </>}
                            </tr>)}
                        </tbody>
                    </CustomTableSimple>

                    <Spacer size={20} />
                </>}
            </Main>
        </Content>

        <Routes>
            <Route path={'/:idName/form'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <ItemNameForm />
                    </SubPage>
                </SubPagesContainer>
            )} />

            <Route path={'/form'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <ItemNameForm />
                    </SubPage>
                </SubPagesContainer>
            )} />
        </Routes>

        <Footer />
    </Container>
}

export default ItemName;